module.exports = __webpack_public_path__ + "static/img/kefu.71b1ded.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kefu.jpg
// module id = pmdT
// module chunks = 1